<div class="container-fluid">

  @if (!isProcessing) {
    <div
style="
  font-size: 13px;
  text-align: center;
  margin-top: 5%;
  margin-top: 40%;
  margin-bottom: 20%;
"
      id="isStatusCheck"
      >
      <div id="iswResponse" class="respDiaplay">
        {{ GA_paymentResponse }}
      </div>  <br>
      <button
        (click)="checkPaymentStatus()"
        type="button"
        id="pay-button"
        style="margin-top: 5%; margin-bottom: -10%"
        class="btn btn-lg btn-block checkout_form-button"
        >
        Check Transaction Status
      </button>
    </div>
  }

  @if (isProcessing) {
    <div class="text-center">
      <div
        class="spinner-border spinner-border"
        style="width: 8rem; height: 8rem"
        role="status"
        >
        <span class="sr-only">Loading...</span>
      </div>
      <br /><br />
      <p style="color: black">Processing Payment</p>
    </div>
  }
  <!-- <div class="row justify-content-md-center" style="margin-bottom: 2%">
  <div class="col-xs-12" style="margin-top: 2%; text-align: center">
    <img
      class="col-md-6"
      width="250"
      src="../assets/images/logos.png"
      alt="partners logo"
      />
  </div>
</div> -->
</div>